<template>
  <Modal :id="'cmp-catalog-tracks-search_product'" @cancelled="onCancel">
    <template slot="header">{{$t('product_search_track')}}</template>

    <template slot="body">
      <div class="body-container">
        <span class="heading-info">{{$t('set_main_product')}}</span>

        <SearchList
          :id="'list'"
          :items="list"
          :keyProperty="'product_track_id'"
          :label="'catalog_no'"
          :selectionNumber="'single'"

          @searched="searchTrack"      
        >
          <template v-slot:item="{ item }">
            <tr class="dt-table2--row" @click="e => onTrackSelected(item)">
              <dt class="dt-table2--column">
                <span class="txtov">{{item.catalog_no}}</span>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{item.release_artist}}</span>
              </dt>
              <dt class="dt-table2--column">
                <span class="txtov">{{item.release_title}}</span>
              </dt>
            </tr>
          </template>
        </SearchList>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
    </template>
  </Modal>
</template>

<script>
import Modal from '@dtplugins/modal/modal';
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { Subject } from 'rxjs';
import { createNTableConfig, createTableHeader } from '../../../../plugins/datatable';
import { async } from 'rxjs/internal/scheduler/async';
import { TracksService } from '../../services/tracks.service';
import SearchList from "@dtplugins/search-list/search-list";
import { productsListLDTRoutes } from '../../router/routes';

export default {
  components: {
    Modal,
    SearchList
  },
  data() {
    return {
      searchString: '',
      searchSubject: new Subject(),
      trackSearchString: '',
      productList: [],
      str: '',

    }
  },
  mounted: async function () {
    const res = await TracksService.relatedProducts(this.track_id);
    this.productList = res.data.products;
    console.log('productList res ', res.data.products);    
  },
  computed: {
    list: function () {
      return this.productList || [];
    },
    track_id: function () {
      console.log('track_id me', this.$route.params.track_id);
      return this.$route.params.track_id;
    },    
  },
  methods: {    
    onTrackSelected: async function (selectedProduct) {
      const product_id = selectedProduct.product_id;
      const track_id = this.track_id;

      const res = await TracksService.setMainProduct({
        track_id,
        product_id
      });

      this.$emit("set_main_product", res.data)
    },

    onSearchInputKeyup: function (e) {
      this.trackSearchString = e.target.value;
      this.searchSubject.next(this.trackSearchString);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    searchTrack: async function (searchString) {
      this.trackSearchString = searchString;

      const res = await TracksService.searchProducts({
        str: searchString
      });
      
      this.productList = res.data.products;
    },
  }
}
</script>

<style lang="scss">
.cmp-catalog-tracks-search_product {
  .product-search {
    margin-bottom: 30px;
  }
  .product-search {
    flex: 1;
  }
  .heading-info {
    display: block;
    margin-bottom: 10px;
  }
  .catalog-product_groups-add_products {
    border: 1px solid var(--sprt-5);
  }
}
</style>